const CreditCardTokenization = Backbone.View.extend({
  events: {
    "click [data-tokenize-credit-card]": "tokenizeCreditCard",
    "creditCard:reset": "reflow"
  },
  initialize(options) {
    this.dispatcher = options.dispatcher;

    if (this.$el.data("settings")) {
      this.settings = this.settings = $.extend(
        true,
        this.settings,
        this.$el.data("settings")
      );

      this.$el.removeAttr("data-settings");
    }

    const ccPaymentWrapper = this.$el.parents("[data-payment-card-wrapper]");
    this.ccProfileID = ccPaymentWrapper.find("[data-profile-credit-cards]");
    this.ccNumber = ccPaymentWrapper.find("[data-payment-credit-card-number]");

    this.threadId = this.ccNumber.data("formThreadId");

    this.ccExpMonth = ccPaymentWrapper.find(
      "[data-payment-credit-card-exp-month]"
    );
    this.ccExpYear = ccPaymentWrapper.find(
      "[data-payment-credit-card-exp-year]"
    );

    this.ccFPANNumber = ccPaymentWrapper.find(
      "[data-payment-credit-card-fpan" + this.threadId + "]"
    );

    this.paymentWidgetWrapper = this.$el.closest("[data-payment-widget]");

    this.dispatcher.on("paymentOption:changed", e => {
      this.resetCreditCardWidget();
    });

    this.ccFPANNumberWrapper = this.$(
      "[data-credit-card-type-select-wrapper]"
    ).attr("disabled", true);

    this.templates = {
      messages: Handlebars.compile(
        this.$("[data-messages-template]").html() || ""
      )
    };
  },

  resetCreditCardWidget: function() {
    if (this.ccFPANNumber.val()) {
      this.paymentWidgetWrapper
        .find(
          "[data-profile-credit-cards], [data-credit-card-type-select], [data-credit-card-number]"
        )
        .val("");
    }
  },

  tokenizeCreditCard(event) {
    event.preventDefault();
    const paymentWidgetAmount = this.paymentWidgetWrapper
      .find("[data-payment-amount-input]")
      .not(":disabled")[0].value;

    const cc_data = {
      currency_code: this.settings.currency_code,
      number: this.ccNumber?.val() || "",
      expiration_month: this.ccExpMonth?.val() || "",
      expiration_year: this.ccExpYear?.val() || "",
      profile_id: this.ccProfileID?.val() || null,
      product: this.settings.product,
      amount: paymentWidgetAmount
    };

    this._sendRequest(this.settings.url, { cc_data: cc_data }).then(
      response => {
        if (response.success) {
          // store CC number (FPAN), in hidden field to be sent in the request

          this.ccFPANNumber
            .val(response.data.cc_number || this.ccNumber.val())
            .trigger("change");

          // assign DPAN as Credit Card number
          this.ccNumber
            .val(response.data.dpan_cc_number)
            .attr("readonly", true);

          this.ccFPANNumberWrapper.attr("disabled", true);

          this.$el.addClass("is-disabled").attr("disabled", true);
        }
      }
    );
  },

  _sendRequest(url, data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        dataType: "json",
        cache: false,
        url: url,
        data: data,

        beforeSend: () => {
          this.renderMessages({});
          this.block();
        },

        success: response => {
          this.renderMessages(response.messages);
          this.unblock();

          resolve(response);
        },

        error: () => {
          this.renderMessages({ ajaxFailure: true });
          this.unblock();

          reject(new Error("unable to process the request"));
        }
      });
    });
  },

  reflow: function(e) {
    this.$el.removeClass("is-disabled").removeAttr("disabled");
    this.ccFPANNumber.val("");
    this.$("[data-messages]").empty();
  },

  block() {
    this.$el.addClass("is-loading");
  },
  unblock() {
    this.$el.removeClass("is-loading");
  },
  renderMessages(messages) {
    this.$("[data-messages]").html(this.templates.messages(messages));
  }
});

module.exports = CreditCardTokenization;
